import config from '../../config/config';
import { createQueryParams } from '@nexio/emvio-util-app';
import { buildTableSuccessActionBasedOnCount } from '../../utils/actionCreators';

export const STATEMENTS_LOAD = 'STATEMENTS/STATEMENTS_LOAD';
export const STATEMENTS_SUCCESS = 'STATEMENTS/STATEMENTS_SUCCESS';
export const STATEMENTS_FAILURE = 'STATEMENTS/STATEMENTS_FAILURE';

export const STATEMENT_LOAD = 'STATEMENTS/STATEMENT_LOAD';
export const STATEMENT_SUCCESS = 'STATEMENTS/STATEMENT_SUCCESS';
export const STATEMENT_FAILURE = 'STATEMENTS/STATEMENT_FAILURE';

export const fetchUrl = `${config.reportApiUrl}/statements`;

export function getStatements(filters, page, pageSize, sorters, merchantIds) {
    const queryParamsString = createQueryParams({
        dateKey: 'statementDate',
        filters,
        merchantIds,
        page,
        pageSize,
        sorters
    });

    return {
        failureActionTypeOrCreator: getStatementsFailureActionCreator,
        fetchParams: {
            url: `${fetchUrl}${queryParamsString}`
        },
        loadActionTypeOrCreator: STATEMENTS_LOAD,
        successActionTypeOrCreator: getStatementsSuccessActionCreator
    };
}

export function getStatementsSuccessActionCreator(results) {
    return buildTableSuccessActionBasedOnCount(results, STATEMENTS_SUCCESS, 'statements');
}

export function getStatementsFailureActionCreator(error) {
    return {
        error,
        type: STATEMENTS_FAILURE
    };
}

export function getStatement(path, statementId) {
    return {
        failureActionTypeOrCreator: createGetStatementFailureActionCreator(statementId),
        fetchParams: {
            url: `${config.pdfApiUrl}/statement?path=${path}`
        },
        loadActionTypeOrCreator: createGetStatementLoadActionCreator(statementId),
        successActionTypeOrCreator: createGetStatementSuccessActionCreator(statementId)
    };
}

export function createGetStatementLoadActionCreator(statementId) {
    return () => ({
        statementId,
        type: STATEMENT_LOAD
    });
}

export function createGetStatementSuccessActionCreator(statementId) {
    return (statement) => ({
        statement,
        statementId,
        type: STATEMENT_SUCCESS
    });
}

export function createGetStatementFailureActionCreator(statementId) {
    return (error) => ({
        error,
        statementId,
        type: STATEMENT_FAILURE
    });
}
